export enum AddUserModalProps {
  MODAL_WIDTH = 375,
  HEADING = 'Add User',
  LOADING_INDICATOR = 'Loading...',
  MODAL_HEADING_EDIT = 'Edit User',
  MODAL_HEADING_CREATE = 'Add User',
  ERROR_MESSAGE = 'Required',
  UPDATE_LOGO = 'Update Company Logo',
}

export enum FieldLabels {
  USER_NAME = 'name',
  USER_NAME_PLACEHOLDER = 'User Name',
  USER_NAME_LABEL = 'User Name',
  ROLE = 'role',
  ROLE_PLACEHOLDER = 'Role',
  ROLE_LABEL = 'Role',
  EMAIL = 'email',
  EMAIL_PLACEHOLDER = 'Email',
  EMAIL_LABEL = 'Email',
  PHONE_NUMBER = 'phone',
  PHONE_NUMBER_PLACEHOLER = 'Phone number (optional)',
  PHONE_NUMBER_LABEL = 'Phone Number',
  POSITION = 'position',
  POSITION_PLACEHOLER = 'Position',
  POSITION_LABEL = 'Position',
  addonbefore = '+1',
  ASSOCIATE_BRAND = 'association',
  ASSOCIATE_BRAND_PLACEHOLDER = 'Associate with brand / manufacture unit (optional)',
  ASSOCIATE_BRAND_LABEL = 'Associated site',  // 'Associate brand'
}

export enum ButtonLabels {
  CONFIRM = 'Create',
  EDIT = 'Update',
  CANCEL = 'Cancel',
}
